module.exports = __webpack_public_path__ + "img/sweater1.38121eca.svg";